import { useCallback, useEffect, useRef, useState } from 'react';
import { useSignalR } from './useSignalR';

export interface UseTypingReturn {
  isAgentTyping: boolean;
}

export const useTyping = (): UseTypingReturn => {
  const [isAgentTyping, setIsAgentTyping] = useState(false);
  const timeoutRef = useRef<ReturnType<typeof setTimeout> | null>(null);

  const { subscribe, unsubscribe, isConnected } = useSignalR();

  const clearTypingTimeout = useCallback(() => {
    if (timeoutRef.current) {
      clearTimeout(timeoutRef.current);
      timeoutRef.current = null;
    }
  }, []);

  const handleTypingEvent = useCallback(() => {
    clearTypingTimeout();
    setIsAgentTyping(true);

    timeoutRef.current = setTimeout(() => {
      setIsAgentTyping(false);
      timeoutRef.current = null;
    }, 10 * 1000); // 10 seconds
  }, [clearTypingTimeout]);

  useEffect(() => {
    if (!isConnected) {
      unsubscribe('OnConversationTyping', handleTypingEvent);
      return;
    }

    subscribe('OnConversationTyping', handleTypingEvent);

    return () => {
      unsubscribe('OnConversationTyping', handleTypingEvent);
    };
  }, [subscribe, unsubscribe, handleTypingEvent, isConnected]);

  return {
    isAgentTyping,
  };
};
